module.exports = __webpack_public_path__ + "assets/eraser.05dade7a.svg";